import CoursesApi from '@/api/courses';

export default {
  namespaced: true,
  state: {
    myCourses: [],
    lessons: [],
    doneLessons: [],
  },
  mutations: {
    SET_COURSES(state, val) {
      state.myCourses = val;
    },
    SET_LESSONS(state, val) {
      state.lessons = val;
    },
    SET_DONE_LESSONS(state, val) {
      state.doneLessons = val;
    },
  },
  actions: {
    async getMyCourses({ commit }) {
      // eslint-disable-next-line no-useless-catch
      try {
        const myCourses = await CoursesApi.getCourses();
        commit('SET_COURSES', myCourses.data);
        console.log(myCourses.data);
      } catch (e) {
        throw e;
      }
    },
    async getLessons({ commit }, id) {
      try {
        const lessons = await CoursesApi.getProgram(id);
        commit('SET_LESSONS', lessons.data.lessons);
        commit('SET_DONE_LESSONS', lessons.data.group.lessons);
        return lessons;
      } catch (e) {
        throw e;
      }
    },
    async uploadHomework({
      commit,
      dispatch,
    }, data) {
      try {
        const homework = await CoursesApi.uploadHomeWork(data);
        if (homework.status === 200) {
          dispatch('getLessons', data.get('program_id'));
          return homework;
        }
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async removeHomeWork({ dispatch }, data) {
      try {
        const removedHomeWork = await CoursesApi.removeHomeWork(data.id);
        if (removedHomeWork.status === 200) {
          dispatch('getLessons', data.program_id);
          return removedHomeWork;
        }
        throw new Error('could not delete');
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  },
  getters: {
    doneLessonsIds: (state) => state.doneLessons.map((lesson) => lesson.id),
  },
};
